import React from 'react';
import {RoleGuard} from "../../components/PermissionGuard";
import {OrganizationManagementFeature} from "../../features/organizationManagement/components/OrganizationManagementFeature";

const ALLOWED_ROLES = ['god', 'admin']

const OrganizationManagementPage = ({
  userToken,
  userRole,
  userOrganizationGroup,
}) => (
  <RoleGuard
    role={userRole}
    userToken={userToken}
    allowedRoles={ALLOWED_ROLES}
  >
    <OrganizationManagementFeature
      userToken={userToken}
      userRole={userRole}
      userOrganizationGroup={userOrganizationGroup}
    />
  </RoleGuard>

);

export default OrganizationManagementPage;
